import { useEffect, useMemo, useState } from "react";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import {
  getEffectiveBaseCost,
  getEffectiveCurrency,
  getEffectiveTax,
} from "../../utilis/applicationCostHelpers";
import {
  findGstSettingByCurrency,
  resolveApplicationCostBreakdown,
} from "../../utilis/gstCalculation";

export function useApplicationGst({ cost, currency, tax, details }) {
  const [gstSettings, setGstSettings] = useState([]);

  useEffect(() => {
    const loadGstSettings = async () => {
      try {
        const response = await apiUrl.get("gstSettings", {
          params: { page: 1, perPage: 500 },
        });
        if (response?.data?.status) {
          setGstSettings(response.data.data || []);
        }
      } catch (error) {
        console.error("Failed to load GST settings:", error);
      }
    };

    loadGstSettings();
  }, []);

  const effectiveCost = getEffectiveBaseCost(cost, details);
  const effectiveCurrency = getEffectiveCurrency(currency, details);
  const effectiveTax = getEffectiveTax(tax, details);

  const gstSetting = useMemo(
    () => findGstSettingByCurrency(gstSettings, effectiveCurrency),
    [gstSettings, effectiveCurrency]
  );

  const breakdown = useMemo(
    () =>
      resolveApplicationCostBreakdown({
        baseCostInput: effectiveCost,
        currency: effectiveCurrency,
        taxType: effectiveTax,
        gstSetting,
        savedDetails: details,
      }),
    [effectiveCost, effectiveCurrency, effectiveTax, gstSetting, details]
  );

  const gstPercentage =
    Number(breakdown?.gst_percentage) ||
    Number(gstSetting?.gst_percentage || 0);

  // GST type is chosen by the user (inclusive/exclusive), not from settings.
  const applyCurrencySelection = () => {};

  return {
    gstSetting,
    gstPercentage,
    breakdown,
    effectiveCurrency,
    effectiveTax,
    effectiveCost,
    applyCurrencySelection,
  };
}
